import { RadioGroup } from '@headlessui/react'
import { StarIcon } from '@heroicons/react/24/solid'
import { StarIcon as StarOutlineIcon } from '@heroicons/react/24/outline'
import { motion } from 'framer-motion'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const StarRating = ({ value, onChange }) => {
  return (
    <RadioGroup value={value} onChange={onChange} className='flex space-x-1.5'>
      {[1, 2, 3, 4, 5].map((rating, index) => {
        const filled = rating <= value

        return (
          <RadioGroup.Option
            key={index}
            value={rating}
            className={clsx(
              'cursor-pointer transition duration-200 hover:text-yellow-400',
              filled ? 'text-yellow-400' : 'text-gray-300'
            )}
          >
            <motion.div
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: 'spring', stiffness: 300, damping: 32 }}
            >
              {filled ? (
                <StarIcon className='size-10' />
              ) : (
                <StarOutlineIcon className='size-10' />
              )}
            </motion.div>
          </RadioGroup.Option>
        )
      })}
    </RadioGroup>
  )
}

StarRating.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func
}

export default StarRating
